export { FooterWithSlices as Footer } from './FooterWithSlices';
export { getVariation } from './Footer.components';
